import React from 'react';
import { useLocation, useParams, Link } from 'react-router-dom';
import Navbar from '../Navbar/Navbar';
import './BookingFailed.css'; // New CSS file for this component
import logo from "../BookingSuccess/logo.png"
import roundlogo from "../BookingSuccess/roundlogo.png"

// **IMPORTANT**: If your logo is in the `src` folder (e.g., `src/assets/logo.png`),
// you would import it like this:
// import companyLogo from '../../assets/logo.png'; // Adjust path as needed
// And then use `src={companyLogo}` in the <img> tag.
// If your logo is in the `public` folder (e.g., `public/images/logo.png`),
// you can use `src="/images/logo.png"` directly.

const BookingFailed = () => {
    const location = useLocation();
    const { appointmentId } = useParams(); // Might be 'unknown'

    const errorDetails = location.state?.error;
    const paymentResponse = location.state?.paymentResponse;
    const isSdkFailure = location.state?.isSdkFailure;

    let displayError = "An unknown error occurred with your booking attempt.";
    if (typeof errorDetails === 'string') {
        displayError = errorDetails;
    } else if (errorDetails?.description) { // Razorpay SDK error structure
        displayError = errorDetails.description;
        if (errorDetails.reason) displayError += ` (Reason: ${errorDetails.reason})`;
    }

    // Determine the path for the "Try Booking Again" link
    const tryAgainPath = (appointmentId && appointmentId !== 'unknown' && errorDetails?.metadata?.doctorId)
        ? `/booking/${errorDetails.metadata.doctorId}`
        : '/appointments';


    return (
        <div className="failed-main-wrapper">
            <Navbar />
            <div className="failed-header-banner">
                <div className="failed-container">
                    
                    <h1 className="failed-banner-title">Booking Attempt Unsuccessful</h1>
                    <p className="failed-banner-subtitle">We encountered an issue. Please review the details below.</p>
                </div>
            </div>

            <div className="failed-content-area">
                <div className="failed-container">
                    <div className="failed-confirmation-card"> {/* Reusing card structure */}
                        <div className="failed-card-header">
                            <img 
                                           src={logo}
                                           alt="Your Company Logo" //   <-- REPLACE THIS with appropriate alt text
                                           className="receipt-logo" 
                                       />
                            <div className="failed-icon-wrapper"> {/* Optional brand icon, can be same or different */}
                               <img style={{height:'65px'}} src={roundlogo} alt="" srcset="" />
                            </div>
                            <i className="fas fa-times-circle failed-status-icon"></i> {/* Failure Icon */}
                            <h2 className="failed-status-title">Booking Failed</h2>
                            <p className="failed-greeting-message">
                                We're sorry, but we couldn't complete your booking at this time.
                            </p>
                        </div>

                        <div className="failed-section failed-error-details-section">
                            <h3 className="failed-section-title">
                                <i className="fas fa-exclamation-triangle"></i> Error Information
                            </h3>
                            <div className="failed-error-message-box">
                                <p>{displayError}</p>
                            </div>

                            {(paymentResponse?.razorpay_order_id || (isSdkFailure && errorDetails?.metadata?.order_id)) && (
                                <div className="failed-transaction-info">
                                    <h4>Transaction Reference:</h4>
                                    {paymentResponse?.razorpay_order_id && (
                                        <p className="failed-detail-item">
                                            <span className="failed-detail-label">Razorpay Order ID:</span>
                                            <span className="failed-detail-value failed-order-id">{paymentResponse.razorpay_order_id}</span>
                                        </p>
                                    )}
                                    {isSdkFailure && errorDetails?.metadata?.order_id && !paymentResponse?.razorpay_order_id && (
                                         <p className="failed-detail-item">
                                            <span className="failed-detail-label">Razorpay Order ID:</span>
                                            <span className="failed-detail-value failed-order-id">{errorDetails.metadata.order_id}</span>
                                        </p>
                                    )}
                                    <p className="failed-deduction-note">
                                        If payment was deducted, please note the Order ID above for reference when contacting support.
                                    </p>
                                </div>
                            )}
                        </div>
                        
                        <div className="failed-section failed-next-steps-section">
                             <h3 className="failed-section-title">
                                <i className="fas fa-question-circle"></i> What Next?
                            </h3>
                            <p className="failed-guidance-text">
                                You can try booking your appointment again. If the problem persists, or if you believe payment was debited from your account, please don't hesitate to contact our support team for assistance.
                            </p>
                        </div>


                        <div className="failed-actions">
                            <Link to={tryAgainPath} className="failed-btn failed-btn-primary">
                                <i className="fas fa-redo-alt"></i> Try Booking Again
                            </Link>
                            <Link to="/contact" className="failed-btn failed-btn-secondary">
                                <i className="fas fa-headset"></i> Contact Support
                            </Link>
                        </div>

                        <div className="failed-footer-note">
                            <p><i className="fas fa-info-circle"></i> We apologize for any inconvenience this may have caused. Our team is here to help.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BookingFailed;